import ButtonComponent from "../../../../../CommonComponents/common/button/Button";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './DeleteUserModal.css';

export const DeleteUserModal = ({ openDeleteConfirmationModalData, handleCloseDeleteModal, handleDeleteConfirmation }) => {
    
    const onCloseDeleteModal = () => {
        handleCloseDeleteModal();
    }
    const onClickCancel = () => {
        handleCloseDeleteModal();
    }
    const onClickYes = () => {
        handleDeleteConfirmation();
    }
    return (
        <Dialog open={openDeleteConfirmationModalData} onClose={onCloseDeleteModal} fullWidth maxWidth="xs">
            <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontWeight: 700 }}>
                Remove User Access
                <IconButton onClick={onCloseDeleteModal}><CloseIcon /></IconButton>
            </DialogTitle>
            <DialogContent sx={{ p: 0 }}>
                <DeleteUserModalContent />
            </DialogContent>
            <DialogActions>
                <DeleteUserModalFooter
                    onClickCancel={onClickCancel}
                    onClickYes={onClickYes}
                />
            </DialogActions>
        </Dialog>
    )
}

const DeleteUserModalFooter = ({ onClickCancel, onClickYes }) => {
    return (
        <div className='btn-wrapper' style={{ display: 'flex', gap: 10 }}>
            <ButtonComponent
                label="No"
                type="primary"
                maxWidth="80px"
                onClick={onClickCancel}
            />
            <ButtonComponent
                label="Yes"
                type="secondary"
                maxWidth="80px"
                onClick={onClickYes}
            />
        </div>
    );
}
const DeleteUserModalContent = () => {
    return (
        <div style={{ padding: '16px 20px' }}>
            <p>Do you want to remove user access?</p>
        </div>
    );
}